import {
  SET_SEARCH_PARAMS,
  SET_HOT_GOODS,
  SET_SPECIAL_AREA,
  SET_SPECIAL_AREA_LIST_INIT,
  SET_SPECIAL_AREA_LIST
} from '@/store/mutation-types'
import Vue from 'vue'
import api from '@/api'
const state = {
  /**
   * 初始属性禁止修改
   */
  baseSearchParams: {
    brandName: '',//as brandId , Array String split with ","
    goodsTypeId: '', //二级分类，
    firstCategoryId: '', //一级分类，
    word: '', //search word split with " "
    stockType: '', //enum 0(国内有货) 1(澳洲有货)
  },
  searchParams: {
    brandName: '',//as brandId , Array String split with ","
    goodsTypeId: '', //二级分类，
    firstCategoryId: '', //一级分类，
    word: '', //search word split with " "
    stockType: '', //enum 0(国内有货) 1(澳洲有货)
  },
  hotGoods: [],
  specialArea: [],
  specialAreaListInit: false,
  specialAreaList: [],
}
const mutations = {
  [SET_SEARCH_PARAMS](state, searchParams) {
    Vue.set(state, 'searchParams', searchParams)
  },
  [SET_HOT_GOODS](state, hotGoods) {
    Vue.set(state, 'hotGoods', hotGoods)
  },
  [SET_SPECIAL_AREA](state, specialArea) {
    Vue.set(state, 'specialArea', specialArea)
  },
  [SET_SPECIAL_AREA_LIST_INIT](state, setSpecialAreaList = true) {
    Vue.set(state, 'setSpecialAreaList', setSpecialAreaList)
  },
  [SET_SPECIAL_AREA_LIST](state, specialAreaList) {
    Vue.set(state, 'specialAreaList', specialAreaList)

  }
}
const actions = {
  getHotGoods: ({ commit, state }) => {
    if (state.goods.hotGoods === undefined) {

    } else {
      return state.goods.hotGoods
    }
  },
  initSpecialArea: ({ commit, state }, refresh) => {
    // console.log(state)
    if (state.specialArea === undefined || refresh) {
      api.home.getSpecialArea().then(res => {
        let specialArea = res.result
        commit(SET_SPECIAL_AREA, specialArea)
      })
    }
  },
  cleanSearchWord: ({ commit, state }) => {
    console.log(state);
    state.searchParams.word = "";
    commit(SET_SEARCH_PARAMS, state.searchParams)
  },
  cleanSearchParams: ({ commit }) => {
    commit(SET_SEARCH_PARAMS, {
      brandName: '',//as brandId , Array String split with ","
      goodsTypeId: '', //二级分类，
      firstCategoryId: '', //一级分类，
      word: '', //search word split with " "
      stockType: '', //enum 0(国内有货) 1(澳洲有货)
    })
  },
  specialAreaList: ({ commit, state }) => {
    if (!state.specialAreaListInit) {
      api.home.specialAreaList().then(res => {
        let specialAreaList = res.result
        specialAreaList.forEach((sa, i, arr) => sa.checked = false)
        commit(SET_SPECIAL_AREA_LIST, res.result)
        commit(SET_SPECIAL_AREA_LIST_INIT, true)
      })
    }
  },
  specialAreaChecked: ({ commit, state }, id) => {
    let specialAreaList = state.specialAreaList;
    specialAreaList.forEach(e => e.checked = e.id === id)
    commit(SET_SPECIAL_AREA_LIST, specialAreaList)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js